import { render } from "./RegistriesSettingsSection.vue?vue&type=template&id=677b60b8"
import script from "./RegistriesSettingsSection.vue?vue&type=script&lang=js"
export * from "./RegistriesSettingsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__